import { Typography } from "@suraasa/placebo-ui"
import clsx from "clsx"

interface Props {
  message: string
  className?: string
}

const NoDataCard = ({ className, message }: Props) => {
  return (
    <div
      className={clsx(
        "flex items-center justify-center rounded-[4px] border border-surface-200 bg-white p-3",
        className
      )}
    >
      <Typography>{message}</Typography>
    </div>
  )
}

export default NoDataCard
